import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/document-services/document-services/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const TextBlock = makeShortcode("TextBlock");
const CodeBlock = makeShortcode("CodeBlock");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <TextBlock slots="heading, text, buttons" theme="dark" hasCodeBlock className='bgBlue code-block-button-padding' mdxType="TextBlock" />
    <h5 {...{
      "id": "collaborative-settings"
    }}>{`COLLABORATIVE SETTINGS`}</h5>
    <p>{`For multi-user document collaboration, identify reviewers by name or email address and save annotation settings through custom callbacks (default settings display GUEST as the reviewer name for all comments)`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/document-services/document-services/docs/overview/pdf-embed-api/howtos_comments/#basic-apis-for-commenting"
        }}>{`See documentation`}</a></li>
    </ul>
    <CodeBlock slots="heading, code" repeat="1" languages="JSON, CURL, JSON" mdxType="CodeBlock" />
    <h4 {...{
      "id": "javascript"
    }}>{`JavaScript`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`const profile = {
  userProfile: {
    name: '',
    firstName: '',
    lastName: '',
    email: ''
  }
};

adobeDCView.registerCallback(
  AdobeDC.View.Enum.CallbackType.GET_USER_PROFILE_API,
  function() {
    return new Promise((resolve, reject) => {
      resolve({
        code: AdobeDC.View.Enum.ApiResponseCode.SUCCESS,
        data: profile
    });
  });
  }
);
`}</code></pre>
    {/* <TextBlock slots="buttons"  theme="dark" className='bgBlue'/>
     - [Get free cretentials](/src/pages/gettingstarted.md) */}

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      